import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Services from "../components/Services";
import ServicesList from "../components/ServicesList";
import HowItWorks from "../components/HowItWorks";
import Testimonials from "../components/Testimonials";
import WhyTidy from "../components/WhyTidy";
import Partners from "../components/Partners";
import Blog from "../components/Blog";
import FAQ from "../components/FAQ";
import ServiceAreas from "../components/ServiceAreas";
import JoinTeam from "../components/JoinTeam";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen" style={{ backgroundColor: "#f4ebde" }}>
      <Header />
      <Hero />
      <Services />
      <ServicesList />
      <HowItWorks />
      <Testimonials />
      <Partners />
      <WhyTidy />
      <ServiceAreas />
      <Blog />
      <FAQ />
      <JoinTeam />
      <Footer />
    </div>
  );
}
